import {Injectable} from '@angular/core';
import {StageService} from './stage.service';

declare const THREE: any;

interface IEdgePost {
  intersectionPoint: any;
  post: any;
}

export interface IResult {
  leftPoint: any;
  rightPoint: any;
}

interface IRayInfo {
  direction: any;
  origin: any;
}

export interface ISettings {
  edgeStartPoint: any;
  edgeEndPoint: any;
  floorOffset: number;
  rayInfo?: IRayInfo;
}

@Injectable()
export class EdgePostsSidePointsCalculationService {

  private raycaster;

  constructor(
    private stage: StageService
  ) {
    this.raycaster = new THREE.Raycaster();
  }

  private static excludeDuplicates(posts: IEdgePost[]) {
    const tmp = [];
    return posts.filter(i => {
      const exist = tmp.indexOf(i.post) !== -1;
      tmp.push(i.post);
      return !exist;
    });
  }

  private getEdgePosts(settings: ISettings): IEdgePost[] {
    const allPosts = this.stage.getChildrenByPredicate(obj => obj.name === 'Post' && obj instanceof THREE.Mesh);
    const originOffsetValue = 20;
    const {rayInfo, floorOffset, edgeEndPoint, edgeStartPoint} = settings;
    const rayDirection = rayInfo ? rayInfo.direction : edgeEndPoint.clone().sub(edgeStartPoint).normalize();
    const originOffset = rayDirection.clone().negate().multiplyScalar(originOffsetValue);
    const origin = rayInfo ? rayInfo.origin.add(originOffset) : edgeStartPoint.clone().add(originOffset);
    origin.y += floorOffset;
    const ray = this.raycaster;
    ray.set(origin, rayDirection);
    const endPoint = edgeEndPoint.clone();
    endPoint.y += floorOffset;
    ray.far = Math.round(origin.distanceTo(endPoint));
    return EdgePostsSidePointsCalculationService.excludeDuplicates(ray.intersectObjects(allPosts)
      .map(i => ({post: i.object, intersectionPoint: i.point})));
  }

  private findLeftPoint(postA: IEdgePost, postB: IEdgePost) {
    const ray = this.raycaster;
    const distance = postA.intersectionPoint.distanceTo(postB.intersectionPoint);
    const direction = new THREE.Vector3().subVectors(postA.intersectionPoint, postB.intersectionPoint).normalize();
    ray.set(postB.intersectionPoint, direction);
    ray.far = distance;
    const intersection = ray.intersectObject(postA.post);
    return intersection.length > 0 ? intersection[0].point : undefined;
  }

  private findEdgePostsSidePoints(edgePosts: IEdgePost[]): Array<IResult> {
    let currentIndex = 0;
    const result = [];
    while (currentIndex < edgePosts.length - 1) {
      const first = edgePosts[currentIndex];
      const second = edgePosts[currentIndex + 1];

      const leftPoint = this.findLeftPoint(first, second);

      if (!leftPoint) {
        currentIndex++;
        continue;
      }

      const rightPoint = second.intersectionPoint;

      result.push({
        leftPoint,
        rightPoint
      });

      currentIndex++;
    }
    return result;
  }

  getPoints(settings: ISettings): Array<IResult> {
    const posts = this.getEdgePosts(settings);
    return this.findEdgePostsSidePoints(posts);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/edge-posts-sidePoints-calculation.service.ts